// these are all STAGING currently - add staging/prod
export function getDetails() {
  switch (process.env.REACT_APP_CUSTOMER) {
    case 'frs':
      return {
        website: 'https://denvergranitecountertop.com',
        backgroundColor: '#242425',
        logo: '/logos/logo.png',
        companyName: 'Front Range Stone'
      };
    case 'trindco':
      return {
        website: 'https://www.trindco.com',
        backgroundColor: '#353535',
        logo: '/logos/logo.webp',
        companyName: 'Trindco'
      };
    case 'tcf':
      return {
        website: 'https://tcfmidwest.com',
        backgroundColor: '#FFFFFF',
        logo: '/logos/logo.png',
        companyName: 'The Countertop Factory'
      };
    case 'simple': // staging
      return {
        website: 'https://simpleintegrations.com',
        backgroundColor: '#242425',
        logo: '/logos/logo.png',
        companyName: 'Simple Integrations'
      };
    case 'dev': // dev
      return {
        website: 'https://simpleintegrations.com',
        backgroundColor: '#242425',
        logo: '/logos/logo.png',
        companyName: 'Simple Integrations'
      };
    default:
      throw new Error('REACT_APP_CUSTOMER not set or unknown');
  }
}
